import { Grid } from "@mui/material";
import React from "react";
import Header from "../Header/Header1";
import "./Deposit.scss";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tab,
  Tabs,
} from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import { toast } from "react-hot-toast";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "../Loader";
import PropTypes from "prop-types";
import coins from "../../Img/coins/coin.svg";
import nodata from "../../Img/newnodta.gif";
import btc from "../../Img/btc.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ltc from "../../Img/ltc.svg";
import kcs from "../../Img/kcs.svg";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { Copy } from "../../SvgCollection";
import SideBar from "../SideBar/SideBar";
import { QRCodeSVG } from "qrcode.react";
import usercalls from "../../Axios";
import consts from "../../constant";
import copy from "copy-text-to-clipboard";
import Tooltip from "@mui/material/Tooltip";
import Modal from "@mui/material/Modal";
import Popper from "@mui/material/Popper";
import Popover from "@mui/material/Popover";
import { useUserData } from "../../Contexts/UserContext";
import { getTimeFormat } from "../../Helpers/DateAndTime";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  // border: "2px solid #000",
  borderRadius: "10px",
  // boxShadow: 24,
  p: 2,
};

const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "transparent",
  // border: "2px solid #000",
  // boxShadow: 24,
  p: 4,
};

const Deposit = () => {
  const [value, setValue] = useState(0);

  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [depositSelNew, setDepositSelNew] = useState("Select Coin");
  const [selectNetworkNew, setSelectNetworkNew] = useState("Select Network");
  const [symbolSearch, setSymbolSearch] = useState("");

  const { userData } = useUserData();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [coin, setCoin] = useState("sc");
  const handleChangeCoin = (event) => {
    setCoin(event.target.value);
  };

  const path = usercalls();

  // row data and id
  const location = useLocation();
  const symbol = location?.state;

  const [bank, setBank] = useState("sbi");
  const handleChangeBank = (event) => {
    setBank(event.target.value);
  };

  const [payment, setPayment] = useState("imps");
  const handleChangePayment = (event) => {
    setPayment(event.target.value);
  };

  const [adminBank, setAdminBank] = useState("10");
  const handleChangeAdminBank = (event) => {
    setAdminBank(event.target.value);
  };
  const [network, setNetwork] = useState("10");
  const handleChangeNetwork = (event) => {
    setNetwork(event.target.value);
  };

  const [inputValue, setInputValue] = useState("safasezfawefdcfwafszfcsazf");

  const deposits = [
    {
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      network: "BNB",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
    },
    {
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      network: "BNB",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
    },
    {
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      network: "BNB",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
    },
    {
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      network: "BNB",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
    },
    {
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      network: "BNB",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
    },
  ];
  const filteredData = deposits.filter((row) => {
    const matchesSearch = row.currencyName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [activeStep, setActiveStep] = useState(1);

  const [selectedAsset, setSelectedAsset] = useState("");

  const [selectedNetwork, setSelectedNetwork] = useState("");

  const [openNetwork, setOpenNetwork] = useState(false);
  const [openQr, setOpenQr] = useState(false);

  const handleOpenNetwork = () => {
    if (selectedAsset === "") {
      return toast.error("Please Select Coin");
    } else {
      setOpenNetwork(true);
    }
  };
  const handleCloseNetwork = () => setOpenNetwork(false);

  const navigate = useNavigate();

  const handleNext = () => {
    var next = false;
    if (activeStep == 0) {
      if (!selectedAsset) {
        return toast.error("Please Select Coin");
      } else {
        next = true;
      }
    } else if (activeStep == 1) {
      if (!selectedNetwork) {
        return toast.error("Please Select Network");
      } else {
        next = true;
      }
    } else if (activeStep == 2) {
      navigate("/assets");
    }
    if (next) {
      setActiveStep((prevActiveStep) => {
        return prevActiveStep + 1;
      });
    }
  };

  const [userAddress, setUserAddress] = useState("");
  const [userMemo, setUserMemo] = useState("")

  const [addressLoading, setAddressLoading] = useState(false);

  const getAddress = async () => {
    try {
      setAddressLoading(true);
      const url = `${consts.BackendUrl}/wallet/OwnWalletCreate`;
      var payload = {
        asset_id: selectedAsset?._id,
        network_id: selectedNetwork?._id,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setUserAddress(result?.result);
        setUserMemo(result?.memo)
      }
      setAddressLoading(false);
    } catch (error) {
      setAddressLoading(false);
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (activeStep == 2) {
      if (selectedAsset && selectedNetwork) {
        getAddress();
      }
    }
  }, [activeStep, selectedNetwork]);

  const handleBack = () => {
    setNetwork("10");
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleCopy = (userAddress) => {
    // navigator.clipboard.writeText(userAddress).then(() => {
    copy(userAddress);
    return toast.success("Text Copied");
    // });
  };

  const [account, setAccount] = useState("654654654651354664654");
  const handleCopyBank = () => {
    navigator.clipboard.writeText(account).then(() => {
      return toast.success("Text Copied");
    });
  };

  const [bankName, setBankName] = useState("HDFC");
  const handleCopyName = () => {
    navigator.clipboard.writeText(bankName).then(() => {
      return toast.success("Text Copied");
    });
  };

  const [accName, setAccName] = useState(
    "Dreamster-Exchange Blockchain Tech Pvt Ltd"
  );
  const handleCopyAcc = () => {
    navigator.clipboard.writeText(accName).then(() => {
      return toast.success("Text Copied");
    });
  };

  const [accType, setAccType] = useState("Current");
  const handleCopyType = () => {
    navigator.clipboard.writeText(accType).then(() => {
      return toast.success("Text Copied");
    });
  };

  const [accCode, setAccCode] = useState("HDFC000245");
  const handleCopyCode = () => {
    navigator.clipboard.writeText(accCode).then(() => {
      return toast.success("Text Copied");
    });
  };

  const [imageUrl, setImageUrl] = useState();

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const data = [
    // { currencyName: "Dreamster-Exchange", icon: Dreamster-Exchange },
    { currencyName: "BTC", icon: btc },
    { currencyName: "LTC", icon: ltc },
    { currencyName: "KCS", icon: kcs },
  ];

  const [assetsList, setAssetsList] = useState([]);

  const [History, setHistory] = useState([]);
  const [historyTotal, setHistoryTotal] = useState(0);

  const getHistory = async () => {
    try {
      const url = `${consts.BackendUrl}/wallet/getOwnDepositHistory?page=${page + 1
        }&limit=${rowsPerPage}`;
      const response = await path.postCall({ url });
      const result = await response.json();
      // console.log(result, "result");
      if (result?.success == true) {
        setHistory(result?.result?.docs);
        setHistoryTotal(result?.result?.totalDocs);
        setAddressLoading(false);
      } else {
        setHistory([]);
        setHistoryTotal(0);
        setAddressLoading(false);
      }
      setAddressLoading(false);
    } catch (error) {
      console.log(error, "error");
      setAddressLoading(false);
    }
  };

  const getAssets = async () => {
    try {
      setAddressLoading(true);
      const url = `${consts.BackendUrl}/assets`;
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      if (result?.result?.length > 0) {
        setAssetsList(result?.result);
        setAddressLoading(false);
        if (symbol?.symbol) {
          for (let i = 0; i < result?.result?.length; i++) {
            const element = result?.result[i];
            if (element?.symbol == symbol?.symbol) {
              setSelectedAsset(element);
              setCoin(element?.symbol);
              setAddressLoading(false);
            }
            setAddressLoading(false);
          }
        }
      }
      setAddressLoading(false);
    } catch (error) {
      console.log(error, "error");
      setAddressLoading(false);
    }
  };

  useEffect(() => {
    getAssets();
  }, []);

  useEffect(() => {
    getHistory();
  }, [page]);

  const [copytext, setCopyText] = useState("copy");

  const txidCopy = (data) => {
    setCopyText("copied");
    copy(data);
    setTimeout(() => {
      setCopyText("copy");
    }, 1000);
  };

  useEffect(() => {
    if (activeStep == 2 && open) {
      setSelectedNetwork("");
      setActiveStep(2);
    }
  }, [activeStep, open]);

  useEffect(() => {
    if (userData?.kyc_verify == "false") {
      navigate("/kycverify");
      toast.error("Verify KYC to Deposit");
    }
  }, [userData]);

  return (
    <div className="deposit-full menu-responsive">
      <Header />
      {/* {addressLoading && <Loader />} */}
      <div className="main_flx">
        <SideBar />
        <div className="split_half">
          <div className="deposit-top block-top-padding">
            <div>
              <Box sx={{ width: "100%" }}>
                <Box>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="deposit-tab"
                  >
                    <Tab label="Deposit Crypto" {...a11yProps(0)} />
                    {/* <Tab label="Deposit INR" {...a11yProps(1)} /> */}
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <Grid container spacing={2} justifyContent={"center"}>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <div className="common-box">
                        <Stepper
                          activeStep={-1} // disables automatic collapse
                          orientation="vertical"
                          className="deposit-stepper"
                        >
                          {[0, 1, 2].map((stepIndex) => (
                            <Step
                              key={stepIndex}
                              className="deposit-steps"
                              expanded
                            >
                              <StepLabel>
                                <h3>
                                  {stepIndex === 0 && "Select coin to deposit"}
                                  {stepIndex === 1 && "Select a network"}
                                  {stepIndex === 2 && "Deposit details"}
                                </h3>
                              </StepLabel>

                              {activeStep >= stepIndex && (
                                <StepContent>
                                  {stepIndex === 0 && (
                                    <>
                                      {/* STEP 1 CONTENT */}
                                      <div className="deposit-select">
                                        <div
                                          className="display-2 sel-new cursor"
                                          onClick={() => handleOpen()}
                                        >
                                          {selectedAsset ? (
                                            <div className="display-1  ">
                                              <div className="d-flex drop-img">
                                                <img
                                                  alt="btc"
                                                  src={selectedAsset?.image}
                                                />
                                              </div>
                                              <div>{selectedAsset?.symbol}</div>
                                            </div>
                                          ) : (
                                            depositSelNew
                                          )}

                                          <KeyboardArrowDownIcon
                                            sx={{ fill: "var(--clr-font)" }}
                                          />
                                        </div>
                                        {/* <FormControl fullWidth>
                                          <Select
                                            value={coin}
                                            onChange={handleChangeCoin}
                                            sx={{
                                              "& .MuiInputBase-formControl": {
                                                border: "0px",
                                              },
                                              "& fieldset": {
                                                border:
                                                  "0px solid #d3d1d1 !important",
                                              },
                                            }}
                                          >
                                            <MenuItem value="sc">
                                              Select Coin
                                            </MenuItem>
                                            {assetsList?.map((row, index) => (
                                              <MenuItem
                                                key={index}
                                                value={row?.symbol}
                                                onClick={() =>
                                                  setSelectedAsset(row)
                                                }
                                              >
                                                <div className="display-1">
                                                  <div className="d-flex drop-img">
                                                    <img
                                                      alt="btc"
                                                      src={row?.image}
                                                    />
                                                  </div>
                                                  <div>{row?.symbol}</div>
                                                </div>
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl> */}
                                        <div className="display-1 mt-10">
                                          {assetsList
                                            ?.slice(0, 3)
                                            ?.map((row, i) => (
                                              <div
                                                className="deposits-coins display-3"
                                                key={i}
                                                onClick={() => {
                                                  setCoin(row?.symbol);
                                                  setSelectedAsset(row);
                                                  setActiveStep(1);
                                                  setSelectedNetwork("");
                                                }}
                                              >
                                                <div className="d-flex drop-img">
                                                  <img
                                                    src={row?.image}
                                                    alt="img"
                                                    width={"20px !important"}
                                                  />
                                                </div>
                                                <div>{row?.symbol}</div>
                                              </div>
                                            ))}
                                        </div>
                                      </div>
                                      {/* {activeStep === 0 && (
                                        <Box sx={{ mb: 2 }}>
                                          <Button
                                            variant="contained"
                                            onClick={handleNext}
                                            className="continue-btn"
                                          >
                                            Continue
                                          </Button>
                                        </Box>
                                      )} */}
                                    </>
                                  )}

                                  {stepIndex === 1 && (
                                    <>
                                      {/* STEP 2 CONTENT */}
                                      <div className="deposit-select">
                                        <div
                                          className="display-2 sel-new cursor"
                                          onClick={() => {
                                            handleOpenNetwork();
                                          }}
                                        >
                                          {selectedNetwork ? (
                                            <div className="display-1  ">
                                              <div>
                                                {
                                                  selectedNetwork?.Network_symbol
                                                }
                                              </div>
                                            </div>
                                          ) : (
                                            selectNetworkNew
                                          )}

                                          <KeyboardArrowDownIcon
                                            sx={{ fill: "var(--clr-font)" }}
                                          />
                                        </div>
                                        {/* <FormControl fullWidth>
                                          <Select
                                            value={network}
                                            onChange={handleChangeNetwork}
                                            sx={{
                                              "& .MuiInputBase-formControl": {
                                                border: "0px",
                                              },
                                              "& fieldset": {
                                                border:
                                                  "0px solid #d3d1d1 !important",
                                              },
                                            }}
                                          >
                                            <MenuItem value={10}>
                                              Select network
                                            </MenuItem>
                                            {selectedAsset?.networks?.map(
                                              (net, idx) => (
                                                <MenuItem
                                                  key={idx}
                                                  value={net?.Network_symbol}
                                                  onClick={() =>
                                                    setSelectedNetwork(net)
                                                  }
                                                >
                                                  {net?.Network_symbol}
                                                </MenuItem>
                                              )
                                            )}
                                          </Select>
                                        </FormControl> */}
                                      </div>
                                      {/* {activeStep === 1 && (
                                        <Box sx={{ mb: 2 }}>
                                          <Button
                                            variant="contained"
                                            onClick={handleNext}
                                            className="continue-btn"
                                          >
                                            Continue
                                          </Button>
                                          <Button
                                            onClick={handleBack}
                                            className="back-btn"
                                          >
                                            Back
                                          </Button>
                                        </Box>
                                      )} */}
                                    </>
                                  )}

                                  {stepIndex === 2 && (
                                    <>
                                      {/* STEP 3 CONTENT */}
                                      {addressLoading ? (
                                        <div className="inline-loader">
                                          <Loader />
                                        </div>
                                      ) : (
                                        <>
                                          <div className="deposit-details ">
                                            <div style={{ wordBreak: "break-all" }}>
                                              <div>Address</div>
                                              <div className="copy-address display-2 gap-15">
                                                <div>{userAddress}</div>
                                                <div className="display-1 cursor cpyr">
                                                  <div
                                                    className="d-flex"
                                                    onClick={() => { handleCopy(userAddress) }}

                                                  >
                                                    <Copy />

                                                  </div>
                                                  <QrCode2Icon
                                                    onClick={() => {
                                                      setOpenQr(true);
                                                    }}
                                                    sx={{ fontSize: "30px" }}
                                                  />
                                                </div>

                                              </div>
                                            </div>
                                            {
                                              userMemo &&
                                              <div className="mt-20">
                                                <div>Memo </div>
                                                <div className="copy-address display-2 gap-15">
                                                  <div>{userMemo}
                                                    <div className="memo-req">
                                                      (*MEMO is required, or you will lose your coins)

                                                    </div>

                                                  </div>
                                                  <div className="display-1 cursor cpyr">
                                                    <div
                                                      className="d-flex"
                                                      onClick={() => { handleCopy(userMemo) }}
                                                    >
                                                      <Copy />
                                                    </div>
                                                    {/* <QrCode2Icon
                                                      onClick={() => {
                                                        setOpenQr(true);
                                                      }}
                                                      sx={{ fontSize: "30px" }}
                                                    /> */}
                                                  </div>

                                                </div>
                                              </div>
                                            }

                                            {/* <div className="qrcode-sty">
                                              <QRCodeSVG value={userAddress} />
                                            </div> */}
                                            <div className="display-1 mt-20">
                                              {/* <div
                                                className="copy-div"
                                                onClick={handleCopy}
                                              >
                                                Copy
                                              </div> */}

                                            </div>
                                          </div>

                                          <p className="highlight-text">
                                            Note: Minimum deposit is{" "}
                                            {selectedAsset?.min_deposit}{" "}
                                            {selectedAsset?.symbol}.
                                          </p>
                                          <p>
                                            Only send {selectedAsset?.symbol} to
                                            this address. Sending others may
                                            result in loss.
                                          </p>
                                          <p>
                                            Ensure the contract address matches
                                            the tokens you are depositing.
                                          </p>

                                          {/* {activeStep === 2 && (
                                            <Box sx={{ mb: 2 }}>
                                              <Button
                                                variant="contained"
                                                onClick={handleNext}
                                                className="continue-btn"
                                              >
                                                Finish
                                              </Button>
                                              <Button
                                                onClick={handleBack}
                                                className="back-btn"
                                              >
                                                Back
                                              </Button>
                                            </Box>
                                          )} */}
                                        </>
                                      )}
                                    </>
                                  )}
                                </StepContent>
                              )}
                            </Step>
                          ))}
                        </Stepper>

                        {/* {activeStep === steps.length && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset
          </Button>
        </Paper>
      )} */}
                      </div>
                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                      <div className="custom_acc box_bdr">
                        <h5>FAQ</h5>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={
                              <svg
                                width="21"
                                height="22"
                                viewBox="0 0 21 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                              </svg>
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography>What is Identity Verification?</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              Identity Verification (KYC) is a process where
                              Dreamster-Exchange verifies your identity through
                              personal documents. It's required to access features
                              like withdrawals and rewards.
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={
                              <svg
                                width="21"
                                height="22"
                                viewBox="0 0 21 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                              </svg>
                            }
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                          >
                            <Typography>
                              Why do I need to complete Identity Verification?
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              Identity Verification is required to comply with
                              regulations, enhance account security, and unlock key
                              features like withdrawals, bonuses, and rewards.
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={
                              <svg
                                width="21"
                                height="22"
                                viewBox="0 0 21 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                              </svg>
                            }
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                          >
                            <Typography>
                              Which documents and information are required for
                              Identity Verification?
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              For Identity Verification, you'll need to provide a
                              valid government-issued ID (National ID), proof of
                              address, and a selfie to confirm your identity.
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={
                              <svg
                                width="21"
                                height="22"
                                viewBox="0 0 21 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                  fill="#8C8C8C"
                                  fillOpacity="0.4"
                                />
                              </svg>
                            }
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                          >
                            <Typography>
                              Where can I find help for issues regarding Identity
                              Verification?
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              You can find help in the 'Support' section of Dreamster-Exchange
                              Exchange or contact customer service directly for
                              assistance with any Identity Verification issues.
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </Grid> */}
                  </Grid>
                </CustomTabPanel>
                {/* <CustomTabPanel value={value} index={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <div className="common-box">
                        <div className="deposit-block">
                          <div className="deposit-sub-title">
                            Choose your Bank Account
                          </div>
                          <div className="deposit-select">
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={bank}
                                onChange={handleChangeBank}
                                sx={{
                                  "& .MuiInputBase-formControl": {
                                    border: "0px",
                                  },
                                  "& fieldset": {
                                    border: "0px solid #d3d1d1 !important",
                                  },
                                }}
                              >
                                <MenuItem value="sbi">
                                  SBI Bank - 65248621646464644
                                </MenuItem>
                                <MenuItem value="icici">
                                  ICICI Bank - 7485961236547898
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className="deposit-block">
                          <div className="deposit-sub-title">Amount</div>
                          <div className="deposit-select">
                            <FormControl fullWidth>
                              <TextField
                                fullWidth
                                value={1000}
                                sx={{
                                  "& fieldset": {
                                    border: "0px solid #d3d1d1 !important",
                                  },
                                }}
                              />
                            </FormControl>
                          </div>
                        </div>
                        <div className="deposit-block">
                          <div className="deposit-sub-title">
                            Bank Payment Type
                          </div>
                          <div className="deposit-select">
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={payment}
                                onChange={handleChangePayment}
                                sx={{
                                  "& .MuiInputBase-formControl": {
                                    border: "0px",
                                  },
                                  "& fieldset": {
                                    border: "0px solid #d3d1d1 !important",
                                  },
                                }}
                              >
                                <MenuItem value="imps">IMPS</MenuItem>
                                <MenuItem value="upi">UPI</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className="deposit-block">
                          <div className="deposit-sub-title">UTR No</div>
                          <div className="deposit-select">
                            <FormControl fullWidth>
                              <TextField
                                fullWidth
                                value={657894512398989}
                                sx={{
                                  "& fieldset": {
                                    border: "0px solid #d3d1d1 !important",
                                  },
                                }}
                              />
                            </FormControl>
                          </div>
                        </div>
                        <div className="deposit-block">
                          <div className="deposit-sub-title">
                            Upload Screenshot
                          </div>

                          <div
                            className="deposit-select image-upload"
                            style={{
                              width: "190px",
                              height: "120px",
                              background: "#F7F7F7",
                            }}
                          >
                            {imageUrl && <img src={imageUrl} alt="image" />}
                            {!imageUrl && (
                              <input
                                type="file"
                                onChange={(e) => handleImageUpload(e)}
                              />
                            )}
                            {!imageUrl && (
                              <div className="ctn">
                                <svg
                                  width="40"
                                  height="39"
                                  viewBox="0 0 40 39"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M28.3929 20.8571H21.6071V27.6429C21.6071 28.3893 20.9964 29 20.25 29C19.5036 29 18.8929 28.3893 18.8929 27.6429V20.8571H12.1071C11.3607 20.8571 10.75 20.2464 10.75 19.5C10.75 18.7536 11.3607 18.1429 12.1071 18.1429H18.8929V11.3571C18.8929 10.6107 19.5036 10 20.25 10C20.9964 10 21.6071 10.6107 21.6071 11.3571V18.1429H28.3929C29.1393 18.1429 29.75 18.7536 29.75 19.5C29.75 20.2464 29.1393 20.8571 28.3929 20.8571Z"
                                    fill="#383838"
                                  />
                                </svg>{" "}
                                Image
                              </div>
                            )}
                          </div>
                        </div>
                        <p className="notes mt-20">
                          Lorem ipsum dolor sit amet consectetur. Duis etiam
                          facilisis elit quam. Ut convallis nunc purus curabitur
                          ut sapien facilisis mi quis.
                        </p>
                        <div className="common-btn deposit-submit">
                          <Button>Submit</Button>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <div className="common-box">
                        <div className="deposit-sub-title">
                          Choose the admin bank account
                        </div>
                        <div className="deposit-select">
                          <FormControl fullWidth>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={adminBank}
                              onChange={handleChangeAdminBank}
                              sx={{
                                "& .MuiInputBase-formControl": {
                                  border: "0px",
                                },
                                "& fieldset": {
                                  border: "0px solid #d3d1d1 !important",
                                },
                              }}
                            >
                              <MenuItem value="10">
                                HDFC Bank - 65248621646464644
                              </MenuItem>
                              <MenuItem value="20">
                                SBI Bank - 65248621646464644
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className="account-details">
                          <div className="display-2 p-10">
                            <p className="account-details-title">
                              {" "}
                              Account Number
                            </p>
                            <div className="display-4">
                              <div> {account} </div>
                              <div
                                className="d-flex"
                                onClick={() => handleCopyAcc()}
                              >
                                <Copy />
                              </div>
                            </div>
                          </div>
                          <div className="display-2 p-10">
                            <p className="account-details-title"> Bank Name</p>
                            <div className="display-4">
                              <div> {bankName} </div>
                              <div
                                className="d-flex"
                                onClick={() => handleCopyBank()}
                              >
                                <Copy />
                              </div>
                            </div>
                          </div>
                          <div className="display-2 p-10">
                            <p className="account-details-title">
                              {" "}
                              Account Name
                            </p>
                            <div className="display-4">
                              <div> {accName} </div>
                              <div
                                className="d-flex"
                                onClick={() => handleCopyName()}
                              >
                                <Copy />
                              </div>
                            </div>
                          </div>
                          <div className="display-2 p-10">
                            <p className="account-details-title">
                              {" "}
                              Account Type{" "}
                            </p>
                            <div className="display-4">
                              <div> {accType} </div>
                              <div
                                className="d-flex"
                                onClick={() => handleCopyType()}
                              >
                                <Copy />
                              </div>
                            </div>
                          </div>
                          <div className="display-2 p-10">
                            <p className="account-details-title"> IFSC Code</p>
                            <div className="display-4">
                              <div> {accCode} </div>
                              <div
                                className="d-flex"
                                onClick={() => handleCopyCode()}
                              >
                                <Copy />
                              </div>
                            </div>
                          </div>
                          <div className="display-2 mt-20 deposit-high-amount">
                            <p> Min : 100</p>
                            <p>Max : 20000</p>
                          </div>
                          <div className="display-2 mt-10  deposit-high-amount">
                            <p> Receive Amount : 100</p>
                            <p>Fee : 10</p>
                          </div>
                          <p className="notes mt-10">
                            Once you make the payment to the payee details
                            mentioned above, fill the below form with the
                            correct details to complete the deposit process
                          </p>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </CustomTabPanel> */}
              </Box>
            </div>
          </div>
          <div className="deposit-bottom">
            <div>
              <h3 className="subtitle">Recent Deposits</h3>
              <TableContainer
                sx={{
                  margin: "20px 0",
                  borderRadius: "5px",
                  border: "1px solid var(--border-clr)",
                }}
              >
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="deposit-table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Date & Time</TableCell>
                      <TableCell>Currency</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>TxID</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {History.length > 0 ? (
                      History?.map((row, i) => (
                        <TableRow className="tr_row" key={i}>
                          <TableCell>
                            {" "}
                            {getTimeFormat(row?.createdAt)}
                            {/* {row?.createdAt?.split("T")[0]}:{" "}
                            {row?.createdAt
                              ?.split("T")[1]
                              ?.split(":")
                              .slice(0, 2)
                              .join(":")}{" "} */}
                          </TableCell>
                          <TableCell>
                            <div className="d-flex align-items-center  gap-10">
                              <div>{row?.asset}</div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="d-flex align-items-center">
                              <div>{row?.amount}</div>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              txidCopy(row?.from);
                            }}
                          >
                            <Tooltip title={copytext} arrow placement="top">
                              {row?.from}
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              txidCopy(row?.transactionHash);
                            }}
                          >
                            <Tooltip title={copytext} arrow placement="top">
                              {row?.transactionHash?.slice(0, 10)}...
                              {row?.transactionHash?.slice(-10)}
                            </Tooltip>
                          </TableCell>
                          <TableCell className={"green"}>
                            {row.status}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow className="tr_row text-center">
                        <TableCell align="center" colSpan={7}>
                          <img src={nodata} alt="nodata" />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component="div"
                  count={historyTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-10">
            <div className="coins">Coin</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleClose}
            />
          </div>
          <div className="p-10">
            <div class="inputBox_container">
              <svg
                class="search_icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                alt="search icon"
              >
                <path d="M46.599 46.599a4.498 4.498 0 0 1-6.363 0l-7.941-7.941C29.028 40.749 25.167 42 21 42 9.402 42 0 32.598 0 21S9.402 0 21 0s21 9.402 21 21c0 4.167-1.251 8.028-3.342 11.295l7.941 7.941a4.498 4.498 0 0 1 0 6.363zM21 6C12.717 6 6 12.714 6 21s6.717 15 15 15c8.286 0 15-6.714 15-15S29.286 6 21 6z"></path>
              </svg>
              <input
                class="inputBox"
                id="inputBox"
                type="text"
                placeholder="Search For Coins"
                onChange={(e) => setSymbolSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="top p-10">
            Top
            <div className=" display-1 mt-10">
              {assetsList?.slice(0, 3)?.map((row, i) => (
                <div
                  className="deposits-coins v2 display-3 cursor"
                  key={i}
                  onClick={() => {
                    setCoin(row?.symbol);
                    setSelectedAsset(row);
                    handleClose();
                  }}
                >
                  {/* <div className="d-flex drop-img">
                    <img src={row?.image} alt="img" width={"20px !important"} />
                  </div> */}
                  <div>{row?.symbol}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="select-model-data">
            {assetsList?.filter(
              (row) =>
                symbolSearch.trim() === "" ||
                row.symbol
                  .toLowerCase()
                  .includes(symbolSearch.trim().toLowerCase())
            )?.length > 0 ? (
              assetsList
                ?.filter(
                  (row) =>
                    symbolSearch.trim() === "" ||
                    row.symbol
                      .toLowerCase()
                      .includes(symbolSearch.trim().toLowerCase())
                )
                ?.map((row, index) => (
                  <div
                    key={index}
                    value={row?.symbol}
                    onClick={() => {
                      setSelectedAsset(row);
                      setActiveStep(1);
                      setSelectedNetwork("");
                      handleClose();
                    }}
                    className="cursor"
                  >
                    <div className="display-1 p-10">
                      <div className="d-flex drop-img">
                        <img alt={row?.symbol} src={row?.image} />
                      </div>
                      <div>{row?.symbol}</div>
                    </div>
                  </div>
                ))
            ) : (
              <div
                className="p-10  display-3"
                style={{ color: "#888", height: "100%" }}
              >
                No data found
              </div>
            )}
          </div>
        </Box>
      </Modal>
      <Modal
        open={openNetwork}
        // onClose={handleCloseNetwork}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Network</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseNetwork}
            />
          </div>
          <div className="p-10 select-model-network">
            {selectedAsset?.networks?.map((net, idx) => (
              <div
                key={idx}
                value={net?.Network_symbol}
                onClick={() => {
                  setSelectedNetwork(net);
                  handleCloseNetwork();
                  setActiveStep(2);
                }}
                className="p-10 cursor"
              >
                {net?.Network_symbol}
              </div>
            ))}
          </div>
        </Box>
      </Modal>
      <Modal
        open={openQr}
        onClose={() => setOpenQr(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          {/* <div className="display-2 p-20">
            <div className="coins">Scan QR</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={() => {
                setOpenQr(false);
              }}
            />
          </div> */}
          <Box
            sx={{
              // border: 1,
              p: 2,
              mt: 3,
              borderRadius: "10px",
              bgcolor: "var(--common-card-bg)",
            }}
          >
            <div className=" text-center coins ">{selectedAsset?.symbol}</div>
            <div className="coins text-center ">
              Network: {selectedNetwork?.Network_symbol}
            </div>
            <div className="qrcode-sty mt-30">
              <QRCodeSVG value={userAddress} />
            </div>
            <div className="mt-20 copy-address text-center">
              {userAddress.slice(0, 10)}
              ...
              {userAddress.slice(38, 42)}
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Deposit;
